import {
    Dialog,
    DialogTrigger,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Input,
    Label
} from "@fluentui/react-components";
import { useState } from "react";
import {insertParticipantFromDatabase, updateParticipantFromDatabase} from "../handlers/databasehandler";
import MessageBox from "./MessageBar";

function ChangeParticipantDialog({ buttonText, fetchedParticipant, clubId, onAdded, verifiedStatus = "NEEDS_VERIFICATION", appearance = "primary", className = "", buttonSize = `medium`, altButton = null }) {
    const [errorMsg, setErrorMsg] = useState(null);
    const [firstName, setFirstName] = useState(fetchedParticipant?.first_name ?? "");
    const [lastName, setLastName] = useState(fetchedParticipant?.last_name ?? "");
    const [birthYear, setBirthYear] = useState(fetchedParticipant?.birthYear ?? "");
    const [wsvInfo, setWsvInfo] = useState(fetchedParticipant?.wsvInfo ?? "");

    const handleSave = async () => {
        if (fetchedParticipant != null) {
            const result = await updateParticipantFromDatabase(fetchedParticipant.id, firstName, lastName, birthYear, wsvInfo, verifiedStatus);
            if (result) {
                if (onAdded) onAdded();
            }
        } else {
            const result = await insertParticipantFromDatabase(clubId, firstName, lastName, birthYear, wsvInfo, verifiedStatus);
            if (result) {
                if (onAdded) onAdded();
            } else {
                console.error('Error adding participant');
            }
        }

        setErrorMsg("");
    }

    return (
        <Dialog>
            <DialogTrigger disableButtonEnhancement>
                { altButton ? altButton : <Button as={"a"} appearance={appearance} className={`button ${className}`} size={buttonSize}>{buttonText}</Button> }
            </DialogTrigger>
            <DialogSurface className={`dialog`}>
                <DialogBody>
                    <DialogTitle>{ (fetchedParticipant) ? "Deelnemer Wijzigen" : "Deelnemer Toevoegen"}</DialogTitle>
                    <DialogContent>
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <Label style={{ width: 150 }}>Voornaam</Label>
                                <Input
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    style={{ flex: 1 }}
                                />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <Label style={{ width: 150 }}>Achternaam</Label>
                                <Input
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    style={{ flex: 1 }}
                                />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <Label style={{ width: 150 }}>Geboortejaar</Label>
                                <Input
                                    type="number"
                                    value={birthYear}
                                    onChange={(e) => setBirthYear(e.target.value)}
                                    style={{ flex: 1 }}
                                />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <Label style={{ width: 150 }}>Bondsnummer WSV</Label>
                                <Input
                                    value={wsvInfo}
                                    onChange={(e) => setWsvInfo(e.target.value)}
                                    style={{ flex: 1 }}
                                />
                            </div>
                            {errorMsg && (
                                <MessageBox
                                    intent="error"
                                    title="Error saving participant"
                                    message={errorMsg}
                                    closeButtonFunction={() => setErrorMsg(null)}
                                />
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button as={"a"} className={`button`} appearance="secondary">Annuleren</Button>
                        </DialogTrigger>
                        <DialogTrigger>
                            <Button as={"a"} className={`button`} appearance="primary" onClick={handleSave} disabled={firstName === "" || lastName === ""}>
                                Opslaan
                            </Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}

export default ChangeParticipantDialog;
